const l = [
  {
    status: "off",
    byte: 128
  },
  {
    status: "on",
    byte: 144
  },
  {
    status: "pp",
    byte: 160
  },
  {
    status: "cc",
    byte: 176
  },
  {
    status: "pc",
    byte: 192
  },
  {
    status: "cp",
    byte: 208
  },
  {
    status: "pb",
    byte: 224
  },
  {
    status: "syx",
    byte: 240
  },
  {
    status: "tcqf",
    byte: 241
  },
  {
    status: "spp",
    byte: 242
  },
  {
    status: "ss",
    byte: 243
  },
  {
    status: "tun",
    byte: 246
  },
  {
    status: "clock",
    byte: 248
  },
  {
    status: "start",
    byte: 250
  },
  {
    status: "cont",
    byte: 251
  },
  {
    status: "stop",
    byte: 252
  },
  {
    status: "as",
    byte: 254
  },
  {
    status: "rst",
    byte: 255
  }
], r = [
  "c",
  "c#",
  "d",
  "d#",
  "e",
  "f",
  "f#",
  "g",
  "g#",
  "a",
  "a#",
  "b"
], c = (n) => {
  n < 240 && (n = n & 240);
  const e = l.find(
    (t) => t.byte === n
  );
  return e !== void 0 ? e.status : "invalid";
}, s = (n) => n & 15, u = (n) => {
  const e = n % r.length;
  if (e < 0)
    return null;
  const t = Math.floor(n / r.length) - 1;
  return {
    note: r[e],
    octave: t
  };
}, i = (n) => {
  if (n.length !== 3)
    return null;
  const e = u(n[1]);
  return e === null ? null : {
    channel: s(n[0]),
    velocity: n[2],
    ...e
  };
}, o = (n) => {
  if (n.length !== 3)
    return null;
  const e = u(n[1]);
  return e === null ? null : {
    channel: s(n[0]),
    pressure: n[2],
    ...e
  };
}, f = (n) => n.length !== 3 ? null : {
  channel: s(n[0]),
  controller: n[1],
  value: n[2]
}, g = (n) => n.length !== 2 ? null : {
  channel: s(n[0]),
  program: n[1]
}, p = (n) => n.length !== 2 ? null : {
  channel: s(n[0]),
  pressure: n[1]
}, h = (n) => {
  if (n.length !== 3)
    return null;
  const e = (n[1] & 127) + ((n[2] & 127) << 7) - 8192;
  return {
    channel: s(n[0]),
    bend: e
  };
}, y = (n) => n.length < 5 || n.at(-1) !== 247 ? null : {
  id: [n[1], n[2], n[3]],
  data: n.slice(4, -1)
}, b = (n) => n.length !== 2 ? null : {
  song: n[1]
}, v = (n) => n.length !== 3 ? null : {
  position: (n[1] & 127) + ((n[2] & 127) << 7)
}, m = (n) => {
  if (n.length === 0)
    return {
      status: "invalid",
      rawData: []
    };
  const e = c(n[0]);
  switch (e) {
    case "off":
    case "on": {
      const t = i(n);
      return t === null ? {
        status: "invalid",
        rawData: n
      } : t.velocity === 0 ? {
        status: "off",
        rawData: n,
        ...t
      } : {
        status: e,
        rawData: n,
        ...t
      };
    }
    case "pp": {
      const t = o(n);
      return t === null ? {
        status: "invalid",
        rawData: n
      } : {
        status: e,
        rawData: n,
        ...t
      };
    }
    case "cc": {
      const t = f(n);
      return t === null ? {
        status: "invalid",
        rawData: n
      } : {
        status: e,
        rawData: n,
        ...t
      };
    }
    case "pc": {
      const t = g(n);
      return t === null ? {
        status: "invalid",
        rawData: n
      } : {
        status: e,
        rawData: n,
        ...t
      };
    }
    case "cp": {
      const t = p(n);
      return t === null ? {
        status: "invalid",
        rawData: n
      } : {
        status: e,
        rawData: n,
        ...t
      };
    }
    case "pb": {
      const t = h(n);
      return t === null ? {
        status: "invalid",
        rawData: n
      } : {
        status: e,
        rawData: n,
        ...t
      };
    }
    case "syx": {
      const t = y(n);
      return t === null ? {
        status: "invalid",
        rawData: n
      } : {
        status: e,
        rawData: n,
        ...t
      };
    }
    case "ss": {
      const t = b(n);
      return t === null ? {
        status: "invalid",
        rawData: n
      } : {
        status: e,
        rawData: n,
        ...t
      };
    }
    case "spp": {
      const t = v(n);
      return t === null ? {
        status: "invalid",
        rawData: n
      } : {
        status: e,
        rawData: n,
        ...t
      };
    }
    case "tun":
    case "clock":
    case "start":
    case "cont":
    case "stop":
    case "as":
    case "rst":
      return n.length !== 1 ? {
        status: "invalid",
        rawData: n
      } : {
        status: e,
        rawData: n
      };
  }
  return {
    status: "invalid",
    rawData: n
  };
};
export {
  l as MIDI_MESSAGE_STATUS_BYTE_PAIRS,
  r as MIDI_NOTES,
  p as parseChannelPressureFragment,
  f as parseControlChangeFragment,
  s as parseMidiChannel,
  m as parseMidiMessage,
  i as parseNoteFragment,
  h as parsePitchBendFragment,
  o as parsePolyphonicKeyPressureFragment,
  g as parseProgramChangeFragment,
  v as parseSongPositionPointerFragment,
  b as parseSongSelectFragment,
  c as parseStatusByte,
  y as parseSysExFragment
};
//# sourceMappingURL=index.js.map
